import script from "./unlinked.vue?vue&type=script&lang=ts&setup=true"
export * from "./unlinked.vue?vue&type=script&lang=ts&setup=true"

import "./unlinked.vue?vue&type=style&index=0&id=03ae20a5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ae20a5"]])

export default __exports__